module.exports = __webpack_public_path__ + "img/mew-wallet-icon.3937fcf2.png";